import {
  CotacaoPorData,
  CotadoXEntregue,
  PaisDestinatario,
  TransportadoraData,
} from "./dashboard.types";

export const defaultCotacaoPorData: CotacaoPorData[] = [
  { label: "00:00", value: 0 },
  { label: "01:00", value: 0 },
  { label: "02:00", value: 0 },
  { label: "03:00", value: 0 },
  { label: "04:00", value: 0 },
  { label: "05:00", value: 0 },
  { label: "06:00", value: 0 },
  { label: "07:00", value: 0 },
  { label: "08:00", value: 0 },
  { label: "09:00", value: 0 },
  { label: "10:00", value: 0 },
  { label: "11:00", value: 0 },
  { label: "12:00", value: 0 },
  { label: "13:00", value: 0 },
  { label: "14:00", value: 0 },
  { label: "15:00", value: 0 },
  { label: "16:00", value: 0 },
  { label: "17:00", value: 0 },
  { label: "18:00", value: 0 },
  { label: "19:00", value: 0 },
  { label: "20:00", value: 0 },
  { label: "21:00", value: 0 },
  { label: "22:00", value: 0 },
  { label: "23:00", value: 0 },
];

export const defaultCotacaoXEntregue: CotadoXEntregue[] = [
  {
    label: "2025-02",
    cotacoes: 0,
    entregues: 0,
  },
  {
    label: "2025-03",
    cotacoes: 0,
    entregues: 0,
  },
  {
    label: "2025-04",
    cotacoes: 0,
    entregues: 0,
  },
  {
    label: "2025-05",
    cotacoes: 0,
    entregues: 0,
  },
  {
    label: "2025-06",
    cotacoes: 0,
    entregues: 0,
  },
  {
    label: "2025-07",
    cotacoes: 0,
    entregues: 0,
  },
  {
    label: "2025-08",
    cotacoes: 0,
    entregues: 0,
  },
  {
    label: "2025-09",
    cotacoes: 0,
    entregues: 0,
  },
  {
    label: "2025-10",
    cotacoes: 0,
    entregues: 0,
  },
  {
    label: "2025-11",
    cotacoes: 0,
    entregues: 0,
  },
  {
    label: "2025-12",
    cotacoes: 0,
    entregues: 0,
  },
  {
    label: "2026-01",
    cotacoes: 0,
    entregues: 0,
  },
];

export const defaultTransportadoraData: TransportadoraData[] = [
  { label: "FEDEX", value: 0 },
  { label: "UPS", value: 0 },
];

export const defaultDestinationData: PaisDestinatario[] = [
  { label: "Estados Unidos", value: 120 },
  { label: "Alemanha", value: 80 },
  { label: "China", value: 60 },
  { label: "Canadá", value: 30 },
  { label: "Japão", value: 20 },
];
